import React from "react";
import { useTranslation } from "react-i18next";
import posbossLogo from "assets/images/posbossLogo.png";
import Icon from "Atoms/Icons";
import { WithLoadingComponent } from "Atoms/Loading";

export const LoadingPage = () => {
  const { t } = useTranslation();

  return (
    <div className="bg-neutral-100 ">
      <div className="flex flex-col mx-auto max-w-screen-sm w-full bg-white h-screen items-center justify-center space-y-32">
        <img
          src={posbossLogo}
          alt="posboss Logo"
          className="w-64 animate-pulse"
        />
        <h3 className="text-xl">{t("common.loading")}</h3>
      </div>
    </div>
  );
};

export const LoadingSpinner = ({ ...props }) => {
  return (
    <Icon
      icon="loading"
      className="animate-spin align-middle inline-block"
      {...props}
    />
  );
};

const LoadingError = () => {
  return "failed to load";
};
const Loading = WithLoadingComponent(
  () => (
    <div>
      <LoadingPage />
    </div>
  ),
  () => (
    <div>
      <LoadingError />
    </div>
  )
);
export { useLoadingState } from "Atoms/Loading";
export default Loading;
